<template>
	<div class='Feed'>
		<Post v-if='feed.item_type==="post"'
			:post='feed'
			@update='$emit("update")'
			@delete='$emit("delete")'
			@comment-delete="handleCommentDelete"/>
		<Notification v-else :notification='feed' :contactTypes='contactTypes' />
	</div>
</template>

<script>
import Notification from './components/Notification/Notification.vue';
import Post from './components/Post/Post.vue';
export default {
	name:  'Feed',
	props: {
		feed: {
			type: Object
		},
		contactTypes: {
			type: Object
		}
	},
	components: {
		Notification, Post
	},
	methods: {
		handleCommentDelete(id) {
			this.$emit('comment-delete', id);
		}
	}
};
</script>
